<template>
  <div class="file-upload" :class="{ short: shortView }">
    <div class="message text-muted">
      <span class="message-text mr-1">drop file here or</span>
      <vue-upload-component
        ref="upload"
        :post-action="postUrl_"
        :put-action="putUrl_"
        @input-file="onFileAttach"
        :data="payload"
        :headers="uploadHeaders"
        :active="true"
        :name="name"
        :accept="accept"
        :size="size"
        :extensions="extensions"
        :multiple="true"
        :drop="true"
        :drop-directory="true"
        ><span v-html="shortViewMessage"></span>
      </vue-upload-component>
    </div>
    <div class="plus-wrapper" :class="{ invisible: $refs.upload && !$refs.upload.dropActive }">
      <div class="plus">Drop file!</div>
    </div>
  </div>
</template>

<script>
import { getAuthHeader } from '@/utils/Helpers'
import VueUploadComponent from 'vue-upload-component'
import { mapMutations } from 'vuex'

export default {
  name: 'app-file-upload',
  components: {
    VueUploadComponent
  },
  props: {
    autoUpload: {
      type: Boolean,
      default: false
    },
    name: {
      // dst file attribute name
      type: String,
      default: 'file'
    },
    shortView: {
      type: Boolean,
      default: false
    },
    postUrl: String,
    putUrl: String,
    payload: Object,
    shortViewMessage: {
      type: String,
      default: 'click to upload'
    },
    size: {
      type: Number,
      default: 0
    },
    accept: {
      type: String
    },
    extensions: {
      type: String
    }
  },
  data: () => ({
    isDragOver: false,
    postUrl_: '',
    putUrl_: '', // put method not work correctly // todo: remove it
    file: null,
    errorThrownFileIds: [] // for prevent error duplicate, this plugin have some ugly event model
  }),
  computed: {
    uploadHeaders() {
      return getAuthHeader()
    }
  },
  methods: {
    ...mapMutations('$_sale', {}),
    start() {
      this.$refs.upload.active = true
    },
    setPostUrl(url) {
      this.postUrl_ = url
      if (this.file) {
        this.file.postAction = url
      }
    },
    setPutUrl(url) {
      this.putUrl_ = url
      if (this.file) {
        this.file.putAction = url
      }
    },
    onFileAttach(newFile, oldFile) {
      this.file = newFile
      this.$emit('attach')
      if (this.autoUpload) {
        // Automatic upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.upload.active) {
            this.$refs.upload.active = true
          }
        }

        if (newFile && oldFile && newFile.success && !oldFile.success) {
          // Success
          this.$emit('upload', newFile.response)
        } else if (newFile && oldFile && newFile.error && this.errorThrownFileIds.indexOf(newFile.id) === -1) {
          // Error
          this.errorThrownFileIds.push(newFile.id)
          this.$emit('error', { cause: newFile.error, response: newFile.response })
        }
      }
    }
  },
  watch: {
    postUrl: {
      immediate: true,
      handler(current) {
        this.postUrl_ = current
      }
    }
  }
}
</script>

<style scoped lang="scss">
input,
label {
  cursor: pointer !important;
}

.file-uploads {
  // third party plugin
  cursor: pointer !important;
  color: #218bc3;
  // display: inline; // not work after markup update
  margin: 0;
}

.file-upload {
  max-width: 100%;
  overflow: hidden;
  border: 1px dashed #ccc;
  background: white;
  position: relative;
}

.input-file {
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.plus-wrapper {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;

  .plus {
    color: #fff;
    font-size: 34px;
    line-height: 44px;
  }
}

.message {
  display: flex;
  font-size: 12px;
  padding: 5px;
  align-items: center;
  justify-content: center;
}

.short {
  .message {
    justify-content: left;
    padding-left: 0;
  }

  .message-text {
    display: none;
  }

  &.file-upload {
    border: none;
  }
}
</style>
